module.exports = __webpack_public_path__ + "static/media/26UNRWA3.38134408.jpg";